/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./lucky.vue?vue&type=template&id=ccc0df34&scoped=true"
import script from "./lucky.vue?vue&type=script&lang=js"
export * from "./lucky.vue?vue&type=script&lang=js"
import style0 from "./lucky.vue?vue&type=style&index=0&id=ccc0df34&prod&lang=css"
import style1 from "./lucky.vue?vue&type=style&index=1&id=ccc0df34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc0df34",
  null
  
)

export default component.exports